import updateNewsletterSubscription, { verifyAddAllButton } from './newsletter_index';
import { ready } from './utils';

// Sets or removes an "in progress" state on a card's preference toggle
// If the toggle is currently "in-progress", removes the "in-progress" state
// If the toggle is not in progress but will become in-progress (i.e. has a timeout attached to it), clears the timeout
// Otherwise, sets a timeout which will make the toggle become in progress in the future
const toggleCardInProgress = (elt) => {
  const toggleContainer = elt.closest('.newsletter-subscription-pref-toggle');
  const delay = 500;
  if (toggleContainer.classList.contains('in-progress')) {
    toggleContainer.classList.remove('in-progress');
    delete toggleContainer.dataset.timeoutId;
  } else if (toggleContainer.dataset.timeoutId) {
    clearTimeout(toggleContainer.dataset.timeoutId);
    delete toggleContainer.dataset.timeoutId;
  } else {
    const timeoutId = setTimeout(() => {
      toggleContainer.classList.add('in-progress');
    }, delay);
    toggleContainer.dataset.timeoutId = timeoutId;
  }
};

const initNewsletterSubscribeModal = () => {
  $('.newsletter-subscribe-modal-cover, .newsletter-subscribe-close, .close-modal-btn-wrapper').on(
    'click',
    function (e) {
      $('.newsletter-subscribe-modal-cover').fadeOut('fast');
      $('.newsletter-subscribe-modal-container').fadeOut('fast');
    }
  );

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      $('.newsletter-subscribe-modal-cover, .newsletter-subscribe-modal-container').fadeOut('fast');
    }
  });
};

// this function gets called from two purposes one for individual newsletter from newsletter
// subscribe modal where id gets pass in order show correct flash message.
// second location from subscribe to all where id is null in this case.
const showNewsletterSubscribeModal = (title, description = '', id = null) => {
  const modalContainer = $('.newsletter-subscribe-modal-container');
  $('.newsletter-subscribe-modal-cover').fadeIn('fast');
  modalContainer.fadeIn('fast');

  modalContainer.find('.newsletter-subscribe-modal-name').text(title);
  modalContainer.find('.get-started-button').text(title);
  modalContainer.find('.newsletter-subscribe-modal-description').text(description);
  if (id) {
    modalContainer
      .find('.get-started-button')
      .attr('data-redirect-uri', `/newsletter-post-signup/${id}`);
  }
};

const toggleNewsletterSubscription = async (e) => {
  e.stopPropagation(); // Stop the event bubbling up to prevent duplicate events
  //When the checkbox with the following class is clicked, this function is firing twice. This condition prevents that.
  if (e.target.className === 'checkbox-fill-sm') {
    return;
  }

  const toggle = e.target;
  const card = toggle.closest('.newsletter-card');

  if (card.dataset.pingServer === 'false') {
    document
      .querySelectorAll('.newsletter-card')
      .forEach((el) => el.classList.remove('newsletter-subscribed'));
    card.classList.add('newsletter-subscribed');
    showNewsletterSubscribeModal(
      `Subscribe to ${card.dataset.newsletterTitle}`,
      card.dataset.newsletterDescription,
      card.dataset.newsletterId
    );
    return;
  }

  toggle.removeEventListener('click', toggleNewsletterSubscription);
  toggleCardInProgress(toggle);

  let endpoint;
  if (card.classList.contains('newsletter-subscribed')) {
    endpoint = card.dataset.unsubscribePath;
  } else {
    endpoint = card.dataset.subscribePath;
  }

  const newsletterId = card.dataset.newsletterId;

  try {
    const response = await updateNewsletterSubscription(endpoint, newsletterId);
    if (!response.ok) {
      const responseBody = await response.json();
      if (response.status == 422) {
        location.reload(); // reload the page and show a flash message
        return;
      }
      throw new Error(response.statusText);
    }
    // If the user was previously subscribed, set card to default state (i.e., unsubscribed)
    // Otherwise, if the user is resubscribing, set card to the "subscribed" state
    if (card.classList.contains('newsletter-subscribed')) {
      card.classList.remove('newsletter-subscribed');
    } else {
      card.classList.add('newsletter-subscribed');
    }
    verifyAddAllButton();
    let formControlMainLabel = toggle.parentNode.parentNode.querySelector('.form-control-maintext');
    if (formControlMainLabel) {
      formControlMainLabel.classList.remove('saved');
      void formControlMainLabel.offsetWidth; // Force a reflow to cancel the current animation
      formControlMainLabel.classList.add('saved');
    }
  } finally {
    toggleCardInProgress(toggle);
    toggle.addEventListener('click', toggleNewsletterSubscription);
  }
};

ready(() => {
  const newsletterCardToggles = document.querySelectorAll(
    '.newsletter-card .newsletter-subscription-pref-toggle'
  );
  if (newsletterCardToggles.length > 0) {
    newsletterCardToggles.forEach((elt) =>
      elt.addEventListener('click', toggleNewsletterSubscription)
    );
  }
  initNewsletterSubscribeModal();
});

export default showNewsletterSubscribeModal;
